import React, { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import axios from "axios";
import { json, useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  Fab,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
  ButtonGroup,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialButton from "../../../../components/MaterialButton";
import MaterialSnackbar from "../../../../components/MaterialSnackbar";
import BASEURL from "../../../Utils/Baseurl";
import MaterialSelect from "../../../../components/MasterSelect";
import NotificationsIcon from "@mui/icons-material/Notifications";
import UserDetailsContext from "../../../../context/auth";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
const AddLeaveRequest = () => {
  const navigate = useNavigate();

  const { user, leavedisplay, AccessData, LeaveShow } =
    useContext(UserDetailsContext);
  const [display, setdisplay] = useState(false);
  const [id, setId] = useState(null);
  const alldata = sessionStorage.getItem("user");

  let parsedUser = JSON.parse(alldata);
  let userdata = Array.isArray(parsedUser) ? parsedUser[0] : parsedUser;
  // const id = user?.id;
  const TeamLeaderId = userdata?.teamleader;

  // Check if current user is HR/Admin
  const isAdmin = AccessData && Array.isArray(AccessData) && AccessData.some(
    (item) => item.component === "HrApproval" && item.can_access
  );

  // Employee selector for admin on-behalf flow
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const [snackBar, setSnackBar] = useState({
    Success: false,
    Error: false,
  });

  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const [leaveData, setLeaveData] = useState({
    requestedOn: new Date().toISOString().split("T")[0],
    leaveType: "",
    leaveFrom: "",
    leaveTill: "",
    halfdays: false,
    reason: "",
    requestedOnStatus: "unchecked",
    leaveTypeStatus: "unchecked",
    leaveFromStatus: "unchecked",
    leaveTillStatus: "unchecked",
    reasonStatus: "unchecked",
  });


  const [resource, setResource] = useState({
    leaveTypeData: [],
  });

  useEffect(() => {
    const userId = user?.id;

    // LeaveTypeDropDown(userId);
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id);
    if (id) {
      handlegetleaves(id);
    }
  }, []);

  useEffect(() => {
    getleavetype();
  }, []);

  // Fetch employees for admin on-behalf selector (same branch)
  useEffect(() => {
    if (isAdmin) {
      const fetchEmployees = async () => {
        try {
          const query = `query($branches: [String]) { allUsersDetail(branches: $branches) { id firstName lastName empid category } }`;
          const response = await axios.post(BASEURL, {
            query,
            variables: { branches: userdata?.branch ? [userdata.branch] : [] },
          }, { headers: { "Content-Type": "application/json" } });
          const users = response.data?.data?.allUsersDetail || [];
          const options = users.map((u) => ({
            value: u.id,
            label: `${u.firstName} ${u.lastName} (${u.empid})`,
          }));
          setEmployeeOptions(options);
        } catch (error) {
        }
      };
      fetchEmployees();
    }
  }, [isAdmin]);

  const [leaveoptions, setleaveoptions] = useState([]);
  const [leavecount, setleavecount] = useState([]);


  const getleavetype = async () => {
    let query = `query leavedetailbyme($id:String!){
  leaveDetailsByMe(id: $id){
    user{
      email
    }
    status
    takedLeave
    leaveType {
      id
      leaveType
    }
    leaveCount
    workFromHome
  }
}`;
    const encodedId = btoa(userdata?.id);
    try {
      const response = await axios.post(
        BASEURL,
        {
          query,
          variables: { id: "VXNlck5vZGU6" + "" + encodedId },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Check and handle the response
      const data = response.data.data.leaveDetailsByMe;

      //   // Format data for dropdown
      const formattedOptions = data.map((item) => ({
        value: item.leaveType?.id,
        label: item.leaveType?.leaveType.replace(/_/g, " ").toUpperCase(),
      }));

      const temp = [];
      data?.map((item) => {
        if (
          item?.leaveType?.leaveType !== "loss_of_pay" &&
          item?.leaveType?.leaveType !== "paternity_leave" &&
          item?.leaveType?.leaveType !== "maternity_leave" &&
          item?.leaveType?.leaveType !== "work_from_home"
        ) {
          temp.push(item);
        }
      });
      const formatted = temp.map((item) => ({
        count: item.leaveCount - item.takedLeave,
        leavetype: item.leaveType?.leaveType,
        id: item.leaveType?.id,
      }));

      setleavecount(formatted);
      setleaveoptions(formattedOptions);
    } catch (error) {
      console.error("ERRorrrrr", error.message);

      setConfirmationDialog({
        open: true,
        title: "Error massage",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };


  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      leaveData.leaveTypeStatus === "success" &&
      leaveData.leaveFromStatus === "success" &&
      leaveData.leaveTillStatus === "success" &&
      leaveData.reasonStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };
  const handleAddLeave = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: isAdmin && selectedEmployee
        ? `Are you sure you want to create leave request on behalf of ${selectedEmployee.label}? This will be auto-approved.`
        : "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onLeaveRequestSubmit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const [originalleavedatas, setoriginalleavedatas] = useState(null);

  const handlegetleaves = async (id) => {
    // Log the id to verify if it's being passed correctly

    const query = `
            query get_leave($id: String!) {
                getLeaveById(id: $id) {
                    id
                    requestedOn
                    leaveType{
                        leaveType
                    }
                    leaveFrom
                    leaveTill
                    totalDays
                    reason
                    teamApproval
                    hrApproval
                    halfDay
                    status
                    lastUpdate
                    teamleaderId
                }
            }`;
    const encodedId = btoa(id);
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = response.data;

      if (response.data.errors) {
        console.error("GraphQL Errors:", response.data.errors);
        return;
      }

      const leaveDatass = data.data.getLeaveById;
      const fileterdata = leaveoptions.filter(
        (val) => val.label === leaveDatass.leaveType.leaveType
      );

      setLeaveData(leaveDatass);
      const selectedLeaveType =
        LeaveDetailOptions.find(
          (opt) => opt.value === leaveDatass.leaveType.leaveType
        ) || "";

      setLeaveData({
        ...leaveDatass,
        leaveType: {
          value: leaveDatass.leaveType.leaveType
            .replace(/_/g, " ")
            .toUpperCase(),
          label: leaveDatass.leaveType.leaveType
            .replace(/_/g, " ")
            .toUpperCase(),
        },
      });
      setoriginalleavedatas({
        ...leaveDatass,
        leaveType: {
          value: leaveDatass.leaveType.leaveType,
          label: leaveDatass.leaveType.leaveType,
        },
      });
      setTogglePage({
        ...togglePage,
        view: true,
      });
    } catch (error) {
      setConfirmationDialog({
        open: true,
        title: "Error massage",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const onLeaveRequestSubmit = async () => {
    const query = `mutation requestForLeave($userId:String!
  $teamLeaderId:String!,
  $requestedOn:Date!,
  $leaveType:String!,
  $leaveFrom:String!,
  $leaveTill:String!,
  $halfDay:String,
  $reason:String,
  $autoApprove:Boolean
){
  addleaveApproval(input:{
    userId:$userId,
    teamleaderId:$teamLeaderId,
    requestedOn:$requestedOn,
    leaveType:$leaveType,
    leaveFrom:$leaveFrom,
    leaveTill:$leaveTill,
    halfDay:$halfDay,
    reason:$reason,
    autoApprove:$autoApprove
  }){
    leaveApproval{
      teamleaderId
      requestedOn
      leaveType{
        leaveType
      }
      leaveFrom
      leaveTill
      totalDays
      halfDay
      reason
    }
  }
}`;

    const encodedId = btoa(userdata.id);

    // Determine userId - use selected employee for admin on-behalf
    let targetUserId;
    let autoApprove = false;
    if (isAdmin && selectedEmployee) {
      const selectedEncrypted = btoa(selectedEmployee.value);
      targetUserId = "VXNlck5vZGU6" + "" + selectedEncrypted;
      autoApprove = true;
    } else {
      targetUserId = "VXNlck5vZGU6" + "" + encodedId;
    }

    let val = {
      userId: targetUserId,
      requestedOn: leaveData.requestedOn,
      leaveType: leaveData.leaveType?.value,
      leaveFrom: leaveData.leaveFrom,
      leaveTill: leaveData.leaveTill,
      reason: leaveData.reason,
      teamLeaderId: TeamLeaderId,
      halfDay: leaveData.halfdays,
      autoApprove: autoApprove,
    };


    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            userId: targetUserId,
            requestedOn: leaveData.requestedOn,
            leaveType: leaveData.leaveType.value,
            leaveFrom: leaveData.leaveFrom,
            leaveTill: leaveData.leaveTill,
            reason: leaveData.reason,
            teamLeaderId: TeamLeaderId,
            halfDay: leaveData.halfdays,
            autoApprove: autoApprove,
          },
        }),
      });

      let result = response.data.data.addleaveApproval.leaveApproval;
      if (result !== null) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: isAdmin && selectedEmployee
            ? `Leave approved for ${selectedEmployee.label}`
            : "Leave Submitted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/leave-management");
      }
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      // setSnackBar({
      //     ...snackBar,
      //     Success: true
      // })
      navigate("/leave-management");
    } catch (error) {
      console.error("responseError:", error.response.data);
      setConfirmationDialog({
        open: true,
        title: "Error massage",
        message: error.message,
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const handleLeaveDatachange = (event, selectEvent) => {
    let leaveState = { ...leaveData };
    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "leaveType") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          leaveState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          leaveState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      leaveState[selectEvent.name] = event;
    } else {
      const changeAllowed = true;
      switch (event.target.name) {
        case "leaveFrom":
          {
            const dateLengthRegex = new RegExp(
              "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~]{10,150}$"
            );
            if (dateLengthRegex.test(event.target.value?.trim())) {
              leaveState[event.target.name + "Status"] = "success";
            } else {
              leaveState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "leaveTill":
          {
            const dateLengthRegex = new RegExp(
              "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~]{10,150}$"
            );

            if (dateLengthRegex.test(event.target.value?.trim())) {
              leaveState[event.target.name + "Status"] = "success";
            } else {
              leaveState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "reason":
          {
            const descriptionRegex = new RegExp("^([\\s\\S]{10,100})$");

            if (descriptionRegex.test(event.target.value?.trim())) {
              leaveState[event.target.name + "Status"] = "success";
            } else {
              leaveState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "halfdays": {
          leaveState[event.target.name] = event.target.value;
          leaveState[event.target.name + "Status"] = event.target.checked
            ? "success"
            : "unchecked";
        }

        default:
          break;
      }
      if (changeAllowed) {
        leaveState[event.target.name] = event.target.value;
      }
    }
    setLeaveData(leaveState);
  };

  const LeaveTypeDropDown = async (id) => {
    const query = `  query leaveDetailsUser($id: String!) {
                            leaveConfigurationByMe(id: $id) {
                                id
                                casualLeave
                                sickLeave
                                earnedLeave
                                restrictedLeave
                                user {
                                    id
                                    username
                                }
                            }
                        }`;
    try {
      setPageState({ ...pageState, loading: true });
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Extract Leavetype data from the response
      const LeaveTypeListdata = response.data.data.leaveConfigurationByMe;
      setResource({
        ...resource,
        leaveTypeData: LeaveTypeListdata,
      });
      setPageState({ ...pageState, loading: false, state: "success" });
    } catch (error) {
      console.error("ResponseError:", error.response.data);
      setConfirmationDialog({
        open: true,
        title: "Error massage",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };

  // Available leavetype calculation
  const LeaveDetailOptions = [
    { value: "sickLeave", label: "Sick Leave" },
    { value: "casualLeave", label: "Casual Leave" },
    { value: "earnedLeave", label: "Earned Leave" },
    { value: "restrictedLeave", label: "Restricted Leave" },
    { value: "lossofpay", label: "Loss Of Pay" },
  ];

  const leaveTypeData1 = {
    sickLeave: resource.leaveTypeData[0]?.sickLeave,
    casualLeave: resource.leaveTypeData[0]?.casualLeave,
    earnedLeave: resource.leaveTypeData[0]?.earnedLeave,
    restrictedLeave: resource.leaveTypeData[0]?.restrictedLeave,
    // // lossofpay: resource.leaveTypeData[0]?.casualLeave
  };

  const filteredRoleOptions = LeaveDetailOptions.filter((option) => {
    if (option.value === "SickLeave" && leaveTypeData1.sickLeave <= 0) {
      return false;
    }
    if (option.value === "casualLeave" && leaveTypeData1.casualLeave <= 0) {
      return false;
    }
    if (option.value === "earnedLeave" && leaveTypeData1.earnedLeave <= 0) {
      return false;
    }
    if (
      option.value === "restrictedLeave" &&
      leaveTypeData1.restrictedLeave <= 0
    ) {
      return false;
    }
    return true;
  });

  const calculateMaxEndDate = (selectedLeaveType, startDate) => {
    if (selectedLeaveType && resource[selectedLeaveType]) {
      const availableLeaveCount = resource[selectedLeaveType];
      const start = new Date(startDate);
      const maxEndDate = new Date(start);
      maxEndDate.setDate(start.getDate() + availableLeaveCount - 1);
      return maxEndDate;
    }
    return null;
  };

  // Total days caluculation based of leave from & till
  let date1 = new Date(leaveData.leaveFrom);
  let date2 = new Date(leaveData.leaveTill);
  let Difference_In_Time = date2.getTime() - date1.getTime();
  let Days = Math.round(Difference_In_Time / (1000 * 3600 * 24));
  let Total_Days = Days + 1;

  const onDiscardDesignation = () => {
    if (originalleavedatas) {
      setLeaveData(originalleavedatas); // Reset to original data
    }
    setdisplay(false);
    setTogglePage({
      view: true,
      edit: false,
    });
  };
  const handleeditdata = () => {
    setdisplay(true);
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const LeaveEditRequest = async () => {
    const query = `mutation EditLeaveRequest(
  $id: Int!
  $input: UpdateLeaveRequestInput!
) {
  editLeaveRequest(id:$id, input: $input) {
    updateLeave{
      id
      leaveFrom
      leaveTill
      totalDays
      teamleaderId
      requestedOn
       leaveType {  
        leaveType
      }
      leaveFrom
      leaveTill
      halfDay
      reason
    }
  }
}`;

    const fileterdata = leaveoptions.filter(
      (val) => val.label === leaveData.leaveType.label
    );


    let update = {
      leaveFrom: leaveData.leaveFrom,
      leaveTill: leaveData.leaveTill,
      teamleaderId: TeamLeaderId,
      leaveType: fileterdata[0]?.value,
      halfDay: leaveData.halfDay || false,
      reason: leaveData.reason || "",
    };

    const variables = {
      id: id,
      input: {
        leaveFrom: leaveData.leaveFrom,
        leaveTill: leaveData.leaveTill,
        teamleaderId: TeamLeaderId,
        leaveType: fileterdata[0]?.value,
        halfDay: leaveData.halfDay || false,
        reason: leaveData.reason || "",
      },
    };

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables,
        }),
      });

      let result = response.data.data.editLeaveRequest?.updateLeave;

      if (result !== null) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Leave Updated  Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/leave-management");
      }

      // if(response.data.data.editLeaveRequest.updateLeave){
      //     navigate('/leave-management')
      // }
    } catch (error) {
      console.error("Error in LeaveEditRequest:", error);
      setConfirmationDialog({
        open: true,
        title: "Error massage",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDeleteSubmitLeave();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDeleteSubmitLeave = async () => {
    const query = `
       mutation delete($id:String!){
  DeleteLeaveRequest(id:$id){
		success
  }
}
    `;

    try {
      const response = await axios.post(BASEURL, {
        query: query,
        variables: {
          id: id,
        },
      });

      if (response.data.data.DeleteLeaveRequest.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Leave Deleted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/leave-management");
      } else {
      }
    } catch (error) {
      console.error("An error occurred while deleting the Holiday:", error);
      setConfirmationDialog({
        open: true,
        title: "Error massage",
        message:
          "Sorry for your inconvience, therewwwwwwww is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const [wfhDays, setWfhDays] = useState([
    {
      id: 1,
      count: 12,
      title: "Sick Leave",
    },
    {
      id: 2,
      count: 12,
      title: "Casual Leave",
    },
    {
      id: 3,
      count: 12,
      title: "Earned Leave",
    },
    {
      id: 4,
      count: 12,
      title: "Restricted Leave",
    },
  ]);

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Grid container>
        {leavecount.map((wfh) => (
          <Grid size={{ xs: 12, sm: 3 }} p={1} key={wfh.id} >
            <Card>
              <MaterialBox m={4}>
                <MaterialBox
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Fab
                    color="#DFF2EB"
                    sx={{
                      backgroundColor: "#DFF2EB",
                    }}
                  >
                    {wfh.count}
                  </Fab>
                </MaterialBox>

                <MaterialBox
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    paddingY: 1,
                    borderRadius: "100px",
                    backgroundColor: "#f9f9f9", // light background for text box
                    marginTop: "5%",
                  }}
                >
                  <MaterialTypography
                    component="label"
                    variant="body2"
                    fontWeight="bold"
                    sx={{
                      fontSize: "13px",
                      color: "#333333", // Darker color for readability
                    }}
                  >
                    {wfh.leavetype.replace(/_/g, " ").toUpperCase()}
                  </MaterialTypography>
                </MaterialBox>
              </MaterialBox>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={60}
              >
                {togglePage.view === true || togglePage.edit === true ? (
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Leave Request Details
                  </MaterialTypography>
                ) : (
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Add Leave Request
                  </MaterialTypography>
                )}
                <ButtonGroup
                  variant="outlined"
                  aria-label="Loading button group"
                >
                  {AccessData &&
                    Array.isArray(AccessData) &&
                    AccessData.some(
                      (item) =>
                        item.component === "EditLeave" && item.can_access
                    ) &&
                    leavedisplay && (
                      <>
                        <ButtonGroup
                          variant="outlined"
                          aria-label="Loading button group"
                        >
                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={handleeditdata}
                            startIcon={<EditIcon />}
                          >
                            Edit
                          </MaterialButton>

                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={AddDelete}
                            startIcon={<DeleteIcon />}
                          >
                            Delete
                          </MaterialButton>
                        </ButtonGroup>
                      </>
                    )}
                </ButtonGroup>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <MaterialBox>
            <Grid container spacing={1}>

              {/* Employee Selector - only visible for HR/Admin on new requests */}
              {isAdmin && !id && (
                <Grid size={{ xs: 6, sm: 6 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Select Employee (On Behalf Of) <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialSelect
                    name="employee"
                    value={selectedEmployee}
                    options={employeeOptions}
                    onChange={(selected) => setSelectedEmployee(selected)}
                    isClearable
                    customStyles={{ optionPadding: 20 }}
                  />
                </Grid>
              )}

              <Grid size={{ xs: 6, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Requested Date
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="requestedOn"
                  // type="date"
                  value={new Date().toISOString().slice(0, 10)}
                  onChange={handleLeaveDatachange}
                  error={leaveData.requestedOnStatus === "error"}
                  success={leaveData.requestedOnStatus === "success"}
                  readOnly
                />
              </Grid>

              <Grid size={{ xs: 6, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Leave Type <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="leaveType"
                  filter
                  value={leaveData.leaveType}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleLeaveDatachange} //selectedValue, event
                  // options={leaveoptions.map((value) => {
                  //     return {
                  //         value: value.value,
                  //         label: value.value
                  //     }
                  // })}
                  options={leaveoptions}
                  error={leaveData.leaveTypeStatus === "error" ? true : false}
                  success={
                    leaveData.leaveTypeStatus === "success" ? true : false
                  }
                  isDisabled={togglePage.view === true ? true : false}
                  isClearable
                />
              </Grid>

              <Grid size={{ xs: 6, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Leave From <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="leaveFrom"
                  type="date"
                  // inputProps={{
                  //   min: new Date().toISOString().split("T")[0],
                  // }}
                  value={leaveData.leaveFrom}
                  onChange={handleLeaveDatachange}
                  error={leaveData.leaveFromStatus === "error" ? true : false}
                  success={
                    leaveData.leaveFromStatus === "success" ? true : false
                  }
                  disabled={togglePage.view === true ? true : false}
                />
              </Grid>

              <Grid size={{ xs: 6, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Leave Till <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="leaveTill"
                  type="date"
                  // min={leaveData.leaveFrom}
                  inputProps={{
                    min: leaveData.leaveFrom,
                  }}
                  // maxDate={calculateMaxEndDate(leaveData.leaveType, leaveData.leaveFrom)}
                  // InputProps={{ inputProps: { min: leaveData.leaveFrom, max: 10 } }}
                  value={leaveData.leaveTill}
                  onChange={handleLeaveDatachange}
                  error={leaveData.leaveTillStatus === "error" ? true : false}
                  success={
                    leaveData.leaveTillStatus === "success" ? true : false
                  }
                  disabled={togglePage.view === true ? true : false}
                />
              </Grid>
              <Grid size={{ xs: 6, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Total Days
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="reason"
                  placeholder="Auto generated"
                  value={Total_Days}
                  onChange={handleLeaveDatachange}
                  disabled
                />
              </Grid>
              <Grid size={{ xs: 6, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Half Days
                  </MaterialTypography>
                </MaterialBox>
                <FormControlLabel
                  sx={{ marginLeft: "1%" }}
                  control={
                    <Switch
                      checked={leaveData.halfdays}
                      onChange={(e) =>
                        handleLeaveDatachange({
                          target: { name: "halfdays", value: e.target.checked },
                        })
                      }
                      color="primary"
                    />
                  }
                  label={leaveData.halfday ? "Yes" : "No"}
                  disabled={togglePage.view === true ? true : false}

                  //   success={leaveData.leaveTillStatus === 'success' ? true : false}
                  //   disabled={togglePage.view === true ? true : false}
                />
              </Grid>

              <Grid size={{ xs: 6, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Reason <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="reason"
                  // placeholder="eg. Reason"
                  multiline
                  rows={6}
                  value={leaveData.reason}
                  onChange={handleLeaveDatachange}
                  error={leaveData.reasonStatus === "error"}
                  success={leaveData.reasonStatus === "success"}
                  disabled={togglePage.view === true ? true : false}
                />
                {leaveData.reasonStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Reason should be a minimum 10 characters & maximum 100
                      characters long.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
            </Grid>
          </MaterialBox>
        </CardContent>
        <MaterialBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          {!leavedisplay && (
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              disabled={!checkAllFields()}
              onClick={handleAddLeave}
            >
              Submit
            </MaterialButton>
          )}

          {display && (
            <>
              <MaterialButton
                variant="gradient"
                color="dark"
                onClick={onDiscardDesignation}
              >
                Discard
              </MaterialButton>
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                //  disabled={!checkAllFields()}
                onClick={LeaveEditRequest}
              >
                Update
              </MaterialButton>
            </>
          )}
        </MaterialBox>
        {
          <MaterialSnackbar
            color="success"
            icon={<NotificationsIcon />}
            title="Message"
            content="You have been submitted successfully"
            open={snackBar.Success}
            close={() =>
              setSnackBar({
                success: false,
              })
            }
          />
        }
      </Card>
    </DashboardLayout>
  );
};
export default AddLeaveRequest;
